import { render, staticRenderFns } from "./editGoods.vue?vue&type=template&id=3e2b1734&scoped=true"
import script from "./editGoods.vue?vue&type=script&lang=js"
export * from "./editGoods.vue?vue&type=script&lang=js"
import style0 from "./editGoods.vue?vue&type=style&index=0&id=3e2b1734&prod&scoped=true&lang=css"
import style1 from "./editGoods.vue?vue&type=style&index=1&id=3e2b1734&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2b1734",
  null
  
)

export default component.exports